import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import DiscountsEditForm from './DiscountsEditForm';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import fetchResourceById from 'components/hoc/fetchResourceById';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { fetchDiscount } from 'store/actions/discounts/fetchDiscounts';
import { updateDiscount } from 'store/actions/discounts/updateDiscounts';

class DiscountsEditContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
            id,
        } = this.props;

        const {
            appliance_rules,
            conditions_rules,
            ...otherValues
        } = values;

        if (values.percentage) {
            otherValues.percentage = values.percentage / 100;
        }

        return new Promise((resolve, reject) => {
            dispatchForm({
                onError: reject,
                onSuccess: () => {
                    resolve(history.push(`/discounts/${ id }/show`));
                },
                values: {
                    ...utils.filterEmptyValues(otherValues),
                    appliance_rules: appliance_rules,
                    conditions_rules: conditions_rules,
                },
                id: id,
            });
        });
    }

    render() {
        const {
            data,
            resourceFetchFailed,
            resourceFetchLoading,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('resources.discounts.title'),
                link: '/discounts',
            },
            {
                label: data.title,
                link: `/discounts/${ data.id }/show`,
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.discounts.actions.edit', { title: data.title }) } />

                    <Actions>
                        <ListButton url='/discounts' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <DiscountsEditForm
                            data={ data }
                            form='discounts_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

DiscountsEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(updateDiscount(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
    fetchResourceById({
        action: fetchDiscount,
        resource: 'discounts',
    })
);

export default enhance(DiscountsEditContainer);



// WEBPACK FOOTER //
// ./src/pages/discounts/edit/DiscountsEditContainer.js